import { Component, Input } from '@angular/core';
import { IconModule, TooltipModule } from 'axis-components';

@Component({
  selector: 'app-tooltip-label',
  template: `
    <span
      [attr.aria-label]="ariaLabel || 'Info'"
      axis-tooltip
      [width]="width"
      [content]="content"
    >
      <axis-icon font="custom" icon="information"></axis-icon>
    </span>
  `,
  standalone: true,
  imports: [IconModule, TooltipModule],
})
export class TooltipLabelComponent {
  @Input() content: string = '';
  @Input() width: string = '300px';
  @Input() ariaLabel?: string;
}
